<!--
 * @Author: chenguanbin
 * @Date: 2020-03-16 11:37:06
 * @Desc: 处置详情 - 时间轴
 -->
<template>
  <section>
    <el-scrollbar wrap-class="scrollbar-wrap">
      <ul>
        <li v-for="flow in alertFlowProcessList" :key="flow.d">
          <div class="handle-time">{{ flow.time }}</div>
          <div class="handle-status active">
            {{ getCorrectProcessTypeName(flow) }}
          </div>
          <div v-if="isShowComment(flow)" class="handle-idea">{{ flow.comment }}</div>
          <div v-if="flow.imageUrlList && flow.imageUrlList.length">
            <img v-for="url in flow.imageUrlList" :key="url" :src="url" />
          </div>
          <div
            v-else-if="isShowTemperature && flow.processType === 'alarm'"
            class="temperature-warning"
          >
            <!-- <p>{{ flow.alertData || '-' }}</p>
            <p>{{ alertTypeName }}</p> -->
            <img style="margin-top: 0px;" :src="picAudio" />
          </div>
        </li>
      </ul>
    </el-scrollbar>
  </section>
</template>

<script>
import picAudio from '@/assets/images/realtimeWarning/picture.png'
const OTHERALERTCODE = 'other'
const FLOWALARMTYPE = 'alarm'
export default {
  name: 'DetailTimeline',
  props: {
    alertFlowProcessList: {
      type: Array,
      default: () => []
    },
    isShowTemperature: {
      type: Boolean,
      default: true
    },
    alertTypeName: {
      type: String,
      default: ''
    },
    alertTypeCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      picAudio
    }
  },
  methods: {
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-19 18:30:49
     * @Desc: processType 为entHandle和approval的需要特殊处理
     */
    getCorrectProcessTypeName(flow) {
      if (flow.processType === 'entHandle') {
        return flow.isMistake === 1 ? '误报' : flow.processTypeName
      } else if (flow.processType === 'approval') {
        return flow.isPassed === 1 ? '审核通过' : '退回企业重新处置'
      } else {
        return flow.processTypeName
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-10 14:17:52
     * @Desc: 非其他预警的预警推送不显示处置意见
     */
    isShowComment(flow) {
      return (
        this.alertTypeCode === OTHERALERTCODE ||
        (this.alertTypeCode !== OTHERALERTCODE && flow.processType !== FLOWALARMTYPE)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  height: 100%;
  ul {
    position: relative;
    padding: 0 16px 0 24px;
    // 时间轴竖线
    &::before {
      content: '';
      position: absolute;
      top: 8px;
      bottom: 0;
      left: 4px;
      width: 1px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.12);
    }
  }
  li {
    position: relative;
    margin-top: 16px;
    // 圆点
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: -24px;
      width: 9px;
      height: 9px;
      border-radius: 100%;
      background-color: #e0e0e0;
    }
    div {
      line-height: 20px;
      margin-bottom: 4px;
      color: rgba(0, 0, 0, 0.7);
    }
    .handle-status.active {
      display: inline-block;
      padding: 0 8px;
      line-height: 24px;
      border: 1px solid #ff952c;
      border-radius: 2px;
      color: #ff952c;
      background-color: #fffbf7;
    }
    .handle-idea {
      color: rgba(0, 0, 0, 0.4);
    }
    img {
      width: 100%;
      margin-top: 20px;
    }
    .temperature-warning {
      height: 62px;
      margin-top: 20px;
      // background-image: linear-gradient(135deg, #f4915f 0%, #ffd194 100%);
      display: flex;
      justify-content: space-around;
      align-items: center;
      p:first-child {
        font-size: 36px;
        color: #ffffff;
      }
      p:last-child {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
</style>
